import { useEffect } from 'react'

import { KeySet } from '@eastcoal/common/types/utilities'

import { useCrudModalFormStoreApi } from '../hooks/useStore'
import { CrudModalFormStore } from '../store/interface'

import { CrudModalFormStoreUpdaterProps } from './interface'

const useStoreUpdater = <K extends KeySet<CrudModalFormStore>>(
  key: K,
  value: CrudModalFormStore[K]
) => {
  const { setState } = useCrudModalFormStoreApi()

  useEffect(() => {
    setState({ [key]: value })
  }, [key, value, setState])
}

export const CrudModalFormStoreUpdater = ({
  open,
  onOpenChange
}: CrudModalFormStoreUpdaterProps) => {
  useStoreUpdater('open', open)
  useStoreUpdater('onOpenChange', onOpenChange)

  return null
}
